import { QueryObserverResult } from '@tanstack/react-query';

import CatalogSwiper from '~/src/common/components/CatalogSwiper';
import CardDispatcher from '~/src/common/components/ProductsGrid/CardDispatcher';
import Tracker from '~/src/common/services/Tracker';
import { CategoryProduct } from '~/src/common/typings/category';
import { sendCardEventClick } from '~/src/common/utils/product';
import { ProductPlaceholder } from '~/src/screens/CatalogContent/ListProductsScreen/layout';
import useProductAnalytics from '~/src/screens/Home/HomeSubcategory/useProductAnalytics';

interface Props {
  id: string;
  name: string;
  position: number;
  products?: CategoryProduct[];
  productsCount: number;
  subcategoriesCount: number;
  isLoading: boolean;
  onRefresh: () => Promise<QueryObserverResult<{ items: CategoryProduct[] }>>;
}

const HomeSubcategorySwiper = ({
  id,
  name,
  position,
  products,
  productsCount,
  subcategoriesCount,
  isLoading,
  onRefresh,
}: Props) => {
  const placeholders = Array.from({ length: productsCount }, (_, index) => index);

  const analyticsProperties = useProductAnalytics({
    items: products ?? placeholders,
    position,
    subcategoriesCount,
  });

  const onFirstScroll = () => {
    Tracker.sendEvent('scroll horizontal list', {
      'subcategory name': name,
    });
  };

  return (
    <CatalogSwiper onFirstScroll={onFirstScroll}>
      {isLoading || !products
        ? placeholders.map(i => <ProductPlaceholder id={i.toString()} key={i} />)
        : products?.map(p => (
            <CardDispatcher
              key={p.id}
              product={p}
              eventSource="products list"
              source={{
                type: 'products list',
                detail: {
                  categoryId: id,
                },
              }}
              categoryName="Accueil"
              subcategory={{ id, name }}
              onRefresh={onRefresh}
              onClick={p => {
                sendCardEventClick(products, p, {
                  source: name,
                  ...analyticsProperties,
                });
              }}
              analyticsProperties={analyticsProperties}
            />
          ))}
    </CatalogSwiper>
  );
};

export default HomeSubcategorySwiper;
